import runtimeEnv from "@mars/heroku-js-runtime-env";
import { Hidden, MobileStepper, Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import FormHelperText from "@material-ui/core/FormHelperText";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import { fade, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import axios from "axios";
import { Formik } from "formik";
import moment from "moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  injectStripe,
} from "react-stripe-elements";
import compose from "recompose/compose";
import * as yup from "yup";
import {
  formatLocationIdForBackend,
  removeFalsy,
  renameSqftForBackend,
} from "../helpers";
import FormErrorMessage from "./FormErrorMessage";

import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import accounting from "accounting";

import Button from "@material-ui/core/Button";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";

import JobInfo from "./JobInfo";
import NextBackButtons from "./NextBackButtons";
import ResponsiveMobileStepper from "./ResponsiveMobileStepper";

const salesTaxRate = 0.0675;

const styles = (theme) => ({
  textField: {},
  subheader: {
    fontSize: "1.5rem",
    color: theme.palette.secondary.main,
  },
  reserveButton: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  dueTodayListItemTextPrimary: {
    fontSize: "2rem",
    fontWeight: "500",
  },
  dueTodayPrice: {
    color: theme.palette.secondary.main,
  },
  stripeInputWrapper: {
    margin: `${theme.spacing(2)}px 0`,
  },
  stripeInputNumber: {
    margin: `0 0 ${theme.spacing(2)}px 0`,
  },
  stripeInputExpiry: {
    margin: `${theme.spacing(1)}px ${theme.spacing(2)}px 0 0`,
  },
  stripeInputCcv: {
    margin: `${theme.spacing(1)}px 0 0 ${theme.spacing(1)}px`,
  },
  stripeInputContainerBase: {
    // Adopted from MUI OutlinedInput styles
    padding: "18.5px 14px",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: theme.shape.borderRadius,
  },
  stripeInputContainerFocus: {},
  stripeInputContainerInvalid: {
    // Adopted from MUI OutlinedInput styles
    borderColor: theme.palette.error.main,
  },
  estimateListItemText: {
    textAlign: "right",
  },
});

class Confirm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stripeInputErrors: {
        cardNumber: "",
        cardExpiry: "",
        cardCvc: "",
      },
    };
  }

  handleStripeInputChange = ({ elementType, error }) => {
    const errorMessage = error && error.message;
    this.setState((prevState) => ({
      stripeInputErrors: {
        ...prevState.stripeInputErrors,
        [elementType]: errorMessage || "",
      },
    }));
  };

  handleStripePromoCode = (e) => {
    const promoCode = e.target.value;

    if (promoCode) {
      return axios
        .request({
          method: "get",
          url: runtimeEnv().REACT_APP_API_URL + "/stripepromocode",
          params: {
            promotion_code: promoCode,
          },
        })
        .then((response) => {
          this.props.updateQuote({ ...this.props.quote, ...response.data });
        })
        .catch((error) => {
          console.log(error); //eslint-disable-line no-console
          console.log(error.response); //eslint-disable-line no-console
        });
    } else {
      this.props.updateQuote({
        ...this.props.quote,
        promo_code: null,
        promo_code_id: null,
        amount_off: 0,
        percent_off: 0,
        percentOffAmount: 0,
      });
    }
  };

  render() {
    const { theme, classes } = this.props;

    const stripeInputProps = {
      onChange: this.handleStripeInputChange,
      // Styles to apply to the input itself
      style: {
        base: {
          color: theme.palette.text.primary,
          fontSize: "16px",
          // fontFamily: theme.typography.fontFamily,

          // // color: '#32325D',
          fontWeight: 500,
          fontFamily: "Source Code Pro, Consolas, Menlo, monospace",

          "::placeholder": {
            color: fade(theme.palette.text.primary, 0.5),
          },
          ":-webkit-autofill": {
            color: "#e39f48",
          },
        },
        invalid: {
          color: theme.palette.error.main,
          "::placeholder": {
            color: theme.palette.error.light,
          },
        },
      },
      // Classes to apply to the stripe input container (outside of the iframe)
      classes: {
        base: classes.stripeInputContainerBase,
        focus: classes.stripeInputContainerFocus,
        invalid: classes.stripeInputContainerInvalid,
      },
    };

    const showStripeInputError = (elementType) => {
      return (
        this.state.stripeInputErrors[elementType] && (
          <FormHelperText error={true} variant="outlined">
            {this.state.stripeInputErrors[elementType]}
          </FormHelperText>
        )
      );
    };

    const subtotalBoxesPrice = Object.keys(this.props.boxesFormValues).reduce(
      (total, boxKey) => {
        const boxQuantity = this.props.boxesFormValues[boxKey];

        if (boxQuantity) {
          const boxPrice = this.props.boxes.find(
            (box) => "box" + box.id === boxKey
          ).price;
          const totalBoxPrice = boxQuantity * boxPrice;

          return totalBoxPrice + total;
        } else {
          return total; //Return total
        }
      },
      0
    );
    const boxesSalesTaxAmount = subtotalBoxesPrice * salesTaxRate;
    const totalBoxesPrice = subtotalBoxesPrice + boxesSalesTaxAmount;

    return (
      <Grid container spacing={4} justify="center" className={classes.root}>
        <Grid item xs={10} md={5}>
          <Typography variant="h4" component="h4">
            Quote
          </Typography>

          <JobInfo
            quote={this.props.quote}
            originDestinationFormValues={this.props.originDestinationFormValues}
            locationsFormValues={{ ...this.props.locationsFormValues }}
            boxesFormValues={this.props.boxesFormValues}
            handleRemoveBoxes={this.props.handleRemoveBoxes}
            boxes={this.props.boxes}
            scheduleFormValues={this.props.scheduleFormValues}
          ></JobInfo>

          <Divider />

          <List>
            <ListItem>
              <ListItemText
                className={classes.estimateListItemText}
                primaryTypographyProps={{
                  className: classes.dueTodayListItemTextPrimary,
                }}
                primary={
                  <span>
                    Due today{" "}
                    <span className={classes.dueTodayPrice}>
                      {accounting.formatMoney(totalBoxesPrice)}
                    </span>
                  </span>
                }
              />
            </ListItem>
          </List>
          <Hidden smDown>
            <Button
              onClick={this.props.handleBack}
              startIcon={<ArrowBackIcon />}
            >
              Back
            </Button>
          </Hidden>
          <Hidden mdUp>
            <MobileStepper
              variant="progress"
              steps={this.props.steps}
              position="bottom"
              activeStep={this.props.activeStep}
              className={classes.mobileStepper}
              backButton={
                <Button size="small" onClick={this.props.handleBack}>
                  <ArrowBackIcon /> Back
                </Button>
              }
            />
          </Hidden>
        </Grid>
        <Grid item xs={10} md={5}>
          <Card>
            <CardContent>
              <Typography gutterBottom variant="h4" component="h4">
                Book for free
              </Typography>

              <Typography paragraph>
                Making a reservation is free. You can cancel your move at no
                penalty 48 hours prior to your reserved moving date and time.
              </Typography>

              <Formik
                validateOnChange={true}
                validationSchema={yup.object({
                  fullName: yup.string().label("Full name").required(),
                  email: yup.string().email().label("Email").required(),
                  phoneNumber: yup.string().label("Phone number").required(), //TODO: validate the phone number itself
                  termsCheckbox: yup
                    .bool()
                    .label("Terms and Conditions Of Service")
                    .oneOf(
                      [true],
                      "Terms and Conditions Of Service must be accepted to reserve your move."
                    )
                    .required(),
                })}
                initialValues={
                  (!(
                    Object.entries(this.props.values).length === 0 &&
                    this.props.values.constructor === Object
                  ) &&
                    this.props.values) || {
                    //If there are already values, use those - make sure it's not just an empty object though, see https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
                    fullName: "",
                    email: "",
                    phoneNumber: "",
                    termsCheckbox: false,
                  }
                }
                onSubmit={(values, actions) => {
                  window.dataLayer.push({
                    event: "reserve",
                    eventProps: {
                      category: "Ecommerce",
                      action: "Click",
                      label: "Page 8 - Reserve",
                    },
                  });

                  // duplicate the object
                  let valuesToSendToBackend = JSON.parse(
                    JSON.stringify(values)
                  );

                  // append other values
                  valuesToSendToBackend = {
                    ...valuesToSendToBackend,
                    ...this.props.originDestinationFormValues,
                    ...this.props.locationsFormValues,
                    ...this.props.quote,
                  };

                  // Filter out boxes with 0 quantity
                  const selectedBoxes = Object.keys(this.props.boxesFormValues)
                    .map((boxKey) => {
                      const id = this.props.boxes.find(
                        (box) => "box" + box.id === boxKey
                      ).id;
                      const amount = this.props.boxesFormValues[boxKey];
                      return { id, amount };
                    })
                    .filter((box) => box.amount > 0);

                  if (selectedBoxes) {
                    valuesToSendToBackend.boxes = selectedBoxes;
                  }

                  // fix the location ids
                  valuesToSendToBackend = formatLocationIdForBackend(
                    valuesToSendToBackend
                  );

                  // Fix sqft values
                  valuesToSendToBackend = renameSqftForBackend(
                    valuesToSendToBackend
                  );

                  // remove any fields that are blank - from example https://coderwall.com/p/urxpsa/remove-falsy-values-or-empty-strings-from-javascript-objects
                  valuesToSendToBackend = removeFalsy(valuesToSendToBackend);

                  // Hardcode fixing the values for backend
                  valuesToSendToBackend.additionalTruckHourlyRate =
                    valuesToSendToBackend.additionalTruckHourlyRate || 0;
                  valuesToSendToBackend.movingDateTime = moment(
                    this.props.scheduleFormValues[0].startDate
                  ).format("YYYY-MM-DDTHH:mm:ss");
                  valuesToSendToBackend.numberOfMovers =
                    valuesToSendToBackend.movers;
                  valuesToSendToBackend.numberOfTrucks =
                    valuesToSendToBackend.trucks;
                  valuesToSendToBackend.professionalPacking =
                    valuesToSendToBackend.professionalPacking || false;
                  valuesToSendToBackend.travelFlatFee =
                    valuesToSendToBackend.flatFee;

                  return this.props.stripe
                    .createToken()
                    .then(({ token, error }) => {
                      const errorMessage = error && error.message;
                      if (errorMessage) {
                        actions.setSubmitting(false);
                        // Stripe will throw back a user friendly error message
                        actions.setStatus({ message: errorMessage });
                      } else {
                        console.log(valuesToSendToBackend);
                        // Token object will exist if error object doesn't
                        const tokenId = token.id;
                        // Add token ID to request data
                        valuesToSendToBackend.stripeTokenId = tokenId;
                        valuesToSendToBackend.uuid = this.props.uuid;
                        //send to backend
                        return axios
                          .request({
                            method: "post",
                            url: runtimeEnv().REACT_APP_API_URL + "/submit",
                            data: valuesToSendToBackend,
                          })
                          .then((response) => {
                            actions.setSubmitting(false);
                            this.props.setConfirmedQuote(response.data);
                            this.props.handleNext(values);
                          })
                          .catch((error) => {
                            actions.setSubmitting(false);
                            actions.setErrors(error.response.data.fields || {});
                            actions.setStatus({
                              message: error.response.data.message,
                            });

                            console.log(error); //eslint-disable-line no-console
                            console.log(error.response); //eslint-disable-line no-console
                          });
                      }
                    });
                }}
                render={({
                  values,
                  errors,
                  status,
                  touched,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  // eslint-disable-next-line no-unused-vars
                  setFieldValue,
                  // eslint-disable-next-line no-unused-vars
                  setFieldError,
                  isSubmitting,
                }) => (
                  <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                    {status && status.message && (
                      <FormErrorMessage message={status.message} />
                    )}

                    <TextField
                      name={"fullName"}
                      label="Full name"
                      className={classes.textField}
                      disabled={isSubmitting}
                      value={values.fullName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.fullName && errors.fullName}
                      error={touched.fullName && !!errors.fullName}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                    />

                    <TextField
                      name={"email"}
                      label="Email"
                      className={classes.textField}
                      disabled={isSubmitting}
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.email && errors.email}
                      error={touched.email && !!errors.email}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                    />

                    <TextField
                      name={"phoneNumber"}
                      label="Phone Number"
                      className={classes.textField}
                      disabled={isSubmitting}
                      value={values.phoneNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.phoneNumber && errors.phoneNumber}
                      error={touched.phoneNumber && !!errors.phoneNumber}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                    />

                    <TextField
                      name={"promoCode"}
                      label="Promo Code"
                      className={classes.textField}
                      disabled={isSubmitting}
                      value={values.promoCode}
                      onChange={this.handleStripePromoCode}
                      onBlur={this.handleStripePromoCode}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                    />

                    <Grid
                      container
                      justify="center"
                      className={classes.stripeInputWrapper}
                    >
                      <Grid item xs={12}>
                        <div className={classes.stripeInputNumber}>
                          <CardNumberElement {...stripeInputProps} />
                          {showStripeInputError("cardNumber")}
                        </div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className={classes.stripeInputExpiry}>
                          <CardExpiryElement {...stripeInputProps} />
                          {showStripeInputError("cardExpiry")}
                        </div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className={classes.stripeInputCcv}>
                          <CardCvcElement {...stripeInputProps} />
                          {showStripeInputError("cardCvc")}
                        </div>
                      </Grid>
                    </Grid>

                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("termsCheckbox")}
                            value={values.termsCheckbox}
                            name="termsCheckbox"
                            lable="termsCheckbox"
                            color="primary"
                          />
                        }
                        label={
                          <span>
                            I agree and understand a minimal charge of 2 hours
                            based on the reserved hourly rate will apply to my
                            move. I have read and agree to Moving Buddy&#39;s{" "}
                            <Link
                              href="https://www.gomovingbuddy.com/terms-conditions-of-service"
                              target="_blank"
                            >
                              Terms and Conditions Of Service
                            </Link>
                          </span>
                        }
                      />
                    </FormGroup>
                    <FormHelperText error={true}>
                      {errors.termsCheckbox}
                    </FormHelperText>

                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      disabled={isSubmitting}
                      className={classes.reserveButton}
                    >
                      Reserve <ArrowForwardIcon />
                    </Button>
                  </form>
                )}
              />

              <Typography variant={"body2"}>
                A credit card is required at the time of your booking to hold
                your reservation. Although a hold will be placed on your card
                prior to your move you will not be charged until you review and
                approve the final hours after your move.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }
}

Confirm.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  stripe: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  quote: PropTypes.object.isRequired,
  setConfirmedQuote: PropTypes.func.isRequired,
  updateQuote: PropTypes.func.isRequired,
  handleRemoveBoxes: PropTypes.func.isRequired,
  originDestinationFormValues: PropTypes.object.isRequired,
  boxesFormValues: PropTypes.object, //May not exist if they skipped boxes
  boxes: PropTypes.array, //May not exist if they skipped boxes
  locationsFormValues: PropTypes.object.isRequired,
  scheduleFormValues: PropTypes.array.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  uuid: PropTypes.string.isRequired,
  steps: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
};

export default compose(
  injectStripe,
  withStyles(styles, { withTheme: true })
)(Confirm);
